// extracted by mini-css-extract-plugin
export var headerBlock = "cmo-module--header-block--mAspT";
export var headingImageWrapper = "cmo-module--headingImageWrapper--kb7SG";